'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMediaRewind = function TiMediaRewind(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17 10.7c-0.8 0-1.6 0.3-2.1 0.8-4 3.9-9.9 9.7-9.9 9.7l9.9 9.6c0.5 0.5 1.3 0.9 2.1 0.9 1.7 0 3-1.4 3-3v-15c0-1.7-1.3-3-3-3z m15 0c-0.8 0-1.6 0.3-2.1 0.8-4 3.9-9.9 9.7-9.9 9.7l9.9 9.6c0.5 0.5 1.3 0.9 2.1 0.9 1.7 0 3-1.4 3-3v-15c0-1.7-1.3-3-3-3z' })
        )
    );
};

exports.default = TiMediaRewind;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/media-rewind.js
// module id = 3664
// module chunks = 0